<script setup lang="ts">
import { computed } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import MainLayout from '@/components/layout/main/MainLayout.vue'
import ToastContainer from '@/components/ui/feedback/ToastContainer.vue'

const route = useRoute()

// Error / unauthorized / not-found render bare; every other route gets the app shell.
const NO_LAYOUT_ROUTE_NAMES = new Set(['error', 'unauthorized', 'not-found'])
const useLayout = computed(() => !NO_LAYOUT_ROUTE_NAMES.has(route.name as string))
</script>

<template>
  <div class="min-h-screen bg-background text-text-title">
    <Suspense>
      <MainLayout v-if="useLayout">
        <RouterView />
      </MainLayout>
      <RouterView v-else />

      <template #fallback>
        <div class="flex min-h-screen items-center justify-center">
          <div class="text-center">
            <div
              class="mx-auto h-10 w-10 animate-spin rounded-full border-4 border-primary border-t-transparent"
            />
            <p class="mt-m text-text-subtitle">Loading…</p>
          </div>
        </div>
      </template>
    </Suspense>

    <ToastContainer />
  </div>
</template>
